<h3 class="dashboard-chart-section-header">Constituent Materials</h3>

<app-epd-dashboard-charts [chartsData]="chartsData" [highcharts]="highcharts"></app-epd-dashboard-charts>

<section class="dashboard-edit-section">
  <ngx-masonry
    (layoutComplete)="reloadMasonryLayout()"
    [options]="{ fitWidth: true, gutter: 40, horizontalOrder: false }"
    [ordered]="true"
  >
    @for (form of section; track form) {
      <app-epd-edit-section
        ngxMasonryItem
        class="masonry-item masonary-width"
        [data]="form"
        (modelChanged)="editSectionUpdated.emit($event)"
      ></app-epd-edit-section>
    }
  </ngx-masonry>
</section>

<section class="dashboard-grid-section">
  @for (data of tableData; track data) {
    <app-epd-info-table [data]="data"></app-epd-info-table>
  }
</section>

@if (canPreview) {
  <section class="dashboard-footer__controls">
    <div class="dashboard-footer__controls-buttons">
      <mds-button
        (click)="preview.emit()"
        [aria-label]="previewButtonLabel"
        [isIconLeft]="true"
        [icon]="'download'"
        type="primary"
      >
        {{ previewButtonLabel }}
      </mds-button>
    </div>
  </section>
}
